import React from 'react';
import LinkAdapterProvider from './LinkAdapterProvider';

const useLinkAdapter = () => {
  const providedAdapter = React.useContext(LinkAdapterProvider.Context);
  return providedAdapter;
};

export default useLinkAdapter;
